import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { authData } = useContext(AuthContext);

  if (!authData) return <Navigate to="/login" replace />;
  if (adminOnly && authData.role !== 'admin') return <Navigate to="/chat" replace />;

  return children;
};

export default ProtectedRoute;
   